export default __webpack_public_path__ + "static/media/3.7efd37ee.png";